import { v4 as uuid } from 'uuid';
import { Gizmo } from '../../../gizmos';
import { IGizmoData, IGizmoEvent, TGetInfoCB } from '../../../types';
import { gnov } from '../../../utils';
import { configV2ToV3 } from '../../../gizmos/utils';
import { downloadFileS3 } from '../utils';

interface IParams {
  data: IGizmoData;
  event?: IGizmoEvent;
  context: {
    gizmo: Gizmo;
  };
}

async function setData({ data, event, context }: IParams) {
  const { gizmo } = context;

  // console.log('cccccccccccconfig: ', gizmo.getConfig());
  // console.log('dddddddddddddata: ', data);
  // console.log('eeeeeeeeeeeeevent: ', event);
  // console.log(
  //   'cccccccccconfigList: ',
  //   event?.data?.gizmoSetData?.rootGizmoConfigList
  // );
  const config = gizmo.getConfig();
  const platformInterface = gizmo.getFoundation()?.getPlatformInterface();
  const annexFormFid = config.ops?.annexForm?.rootGizmoFid;
  const rootGizmoFid = gizmo.getCallbacks().getInfoCB({
    type: 'rootGizmoFid',
  });
  const rootGizmoDataFid = gizmo.getCallbacks().getInfoCB({
    type: 'rootGizmoDataFid',
  });
  // console.log('rootGizmoFid: ', config.ops?.annexForm?.rootGizmoFid);
  if (
    config.ops?.annexForm?.rootGizmoFid &&
    event?.data?.gizmoSetData?.rootGizmoConfigList &&
    Array.isArray(event.data.gizmoSetData.rootGizmoConfigList) &&
    event?.data?.gizmoSetData?.filledFormList &&
    Array.isArray(event.data.gizmoSetData.filledFormList) &&
    event.data.gizmoSetData.formList &&
    Array.isArray(event.data.gizmoSetData.formList) &&
    rootGizmoFid &&
    Array.isArray(data) &&
    annexFormFid &&
    platformInterface
  ) {
    // const rootGizmoConfig = event.data.gizmoSetData.rootGizmoConfigList.find(
    //   (rootGizmoConfig: any) =>
    //     rootGizmoConfig.fid === config.ops?.annexForm?.rootGizmoFid
    // );
    const parentRootGizmoConfig =
      event.data.gizmoSetData.rootGizmoConfigList[0];
    let childRootGizmoDataList = event.data.gizmoSetData.filledFormList.filter(
      (rgd: any) => rgd.formId !== parentRootGizmoConfig.fid
    );
    // const childRootGizmoDataList = event.data.gizmoSetData.filledFormList
    //   .filter((rgd: any) => rgd.formId !== parentRootGizmoConfig.fid)
    //   .map((rgd: any) => {
    //     const r = rgd;
    //     const d = data.find((d: any) => d.afd.filledFormId === r.filledFormId);
    //     const fid = uuid();

    //     r.belongsTo = {
    //       formId: rootGizmoFid,
    //       filledFormId: rootGizmoDataFid,
    //       answerId: gizmo.getConfig().fid,
    //     };
    //     r.formId = annexFormFid;
    //     r.fid = fid;
    //     r.filledFormId = fid;
    //     delete r.id;
    //     delete r._id;

    //     console.log('dddddddddddddddd: ', d);

    //     if (d) {
    //       d.afd.filledFormId = fid;
    //       d.afd.formId = annexFormFid;
    //       delete d.afd.id;
    //     }

    //     return r;
    //   });

    // console.log('ppppppppparent: ', parentRootGizmoConfig);
    // console.log('ccccch: ', childRootGizmoDataList);
    // console.log('dddddddddddata: ', data);
    // console.log('fffffffffffffrootGizmoConfig: ', rootGizmoConfig);
    for (const register of childRootGizmoDataList) {
      register.downloaded = true;

      // console.log('==-=-=-=-=-=r: ', JSON.stringify(register));
      const form = event.data.gizmoSetData.formList.find(
        (f: any) => f.id === register.formId
      );
      const rootGizmoData = event.data.gizmoSetData.rootGizmoDataList?.find(
        (rgd: any) => rgd.fid === register.filledFormId
      );
      // console.log('ffffffffffffffffffffffform: ', form);
      // console.log('GGGGGGGGGGGGGGGGGGG: ', rootGizmoData);

      for (const fid in register.answers) {
        const attachmentId = gnov(register.answers[fid], '0.attachmentId');

        if (attachmentId) {
          // We used for to search for the gizmo because it's flat
          const questionConfig = form?.questions?.find(q => q.f_id === fid);
          // console.log('aaaaaaaaaaaaaaaaaaaattId: ', attachmentId);
          // console.log('qC: ', questionConfig);
          if (questionConfig && rootGizmoData?.d) {
            const rootGizmoConfig = event.data.gizmoSetData.rootGizmoConfigList.find(
              (rgc: any) => rgc.fid === register.formId
            );
            const gizmoConfig = configV2ToV3({
              config: questionConfig,
            });
            const gizmoData = rootGizmoData.d[fid];

            // console.log('rG: ', rootGizmoConfig);
            // console.log('gc: ', gizmoConfig);
            if (rootGizmoConfig && gizmoData && !Array.isArray(gizmoData)) {
              const getInfoCB: TGetInfoCB = ({ type }) => {
                if (type === 'rootGizmoFid' && rootGizmoConfig) {
                  return rootGizmoConfig.fid;
                } else if (type === 'rootGizmoDataFid' && register) {
                  return register.fid;
                }

                return undefined;
              };

              const g: any = {
                getDao: gizmo.getDao,
                getCallbacks: () => ({
                  getInfoCB,
                }),
                getConfig: () => gizmoConfig,
              };

              const file = await downloadFileS3({
                data: gizmoData,
                context: {
                  gizmo: g,
                },
              });

              if (file) {
                const fileName = file.name;
                const fileExtension = fileName.split('.').pop();
                if (fileExtension) {
                  platformInterface.fileSet({
                    path: '',
                    fileFid: attachmentId,
                    fileName,
                    fileExtension,
                    file,
                  });
                }
              }
            }
          }
        }
      }

      // await gizmo
      //   .getDao()
      //   ?.getDatabase()
      //   ?.set({
      //     type: 'filledForms',
      //     value: register,
      //     update: true,
      //   });
    }

    childRootGizmoDataList = childRootGizmoDataList.map((rgd: any) => {
      const r = rgd;
      const d = data.find((d: any) => d.afd.filledFormId === r.filledFormId);
      const fid = uuid();

      r.belongsTo = {
        formId: rootGizmoFid,
        filledFormId: rootGizmoDataFid,
        answerId: gizmo.getConfig().fid,
      };
      r.formId = annexFormFid;
      r.fid = fid;
      r.filledFormId = fid;
      delete r.id;
      delete r._id;

      if (d) {
        d.afd.filledFormId = fid;
        d.afd.formId = annexFormFid;
        delete d.afd.id;
      }

      return r;
    });

    for (const register of childRootGizmoDataList) {
      await gizmo
        .getDao()
        ?.getDatabase()
        ?.set({
          type: 'filledForms',
          value: register,
          update: true,
        });
    }

    return data;
  }

  return undefined;
}

export default setData;
